import React from 'react';
import { fmtInt, fmtPct, fmtRatio } from '../../utils/format';
interface FunnelBarsProps {
  members: number;
  registeringMembers: number;
  registrations: number;
  conversionRate: number;
  regsPerMember: number;
  compact?: boolean;
}
function Stage({
  label,
  value,
  color,
  max,
  compact
}: {
  label: string;
  value: number;
  color: string;
  max: number;
  compact?: boolean;
}) {
  return <div data-id="element-179" data-mp="3aqzl0ztr452s">
      <div className="flex items-baseline justify-between gap-3" data-id="element-180" data-mp="3ar7xwrpvjadz">
        <span className={`${compact ? 'text-xs' : 'text-[13px]'} font-medium text-ink`} data-id="element-181" data-mp="3fqkkdbcu2fg1">{label}</span>
        <span className={`${compact ? 'text-base' : 'text-xl'} font-semibold tabular-nums text-navy`} data-id="element-182" data-mp="31qt04svq42tl">{fmtInt(value)}</span>
      </div>
      <div className={`mt-1.5 w-full rounded-sm bg-canvas ${compact ? 'h-3' : 'h-5'}`} data-id="element-183" data-mp="36p4cba9hqpez">
        <div className={`h-full rounded-sm ${color}`} style={{
        width: `${Math.max(2, value / max * 100)}%`
      }} data-id="element-184" data-mp="zywm9cm32gvn" />
      </div>
    </div>;
}
function Connector({
  label,
  value,
  compact
}: {
  label: string;
  value: string;
  compact?: boolean;
}) {
  return <div className={`flex items-center gap-2 ${compact ? 'py-2' : 'py-3'}`} data-id="element-185" data-mp="1xt789jq8fko3">
      <span className="ml-3 h-5 w-px bg-line-strong" aria-hidden data-id="element-186" data-mp="1tt6w65qlvlk7" />
      <span className="inline-flex items-center gap-2 rounded border border-line bg-white px-2 py-1 text-xs" data-id="element-187" data-mp="27ld0mukec43t">
        <span className="text-ink-muted" data-id="element-188" data-mp="22n1q0hma1pkj">{label}</span>
        <b className="tabular-nums text-accent-strong" data-id="element-189" data-mp="22ocwip73xbfc">{value}</b>
      </span>
    </div>;
}

/** Members → unique members who registered → registrations, all inside the same date range. */
export function FunnelBars({
  members,
  registeringMembers,
  registrations,
  conversionRate,
  regsPerMember,
  compact
}: FunnelBarsProps) {
  const max = Math.max(members, registrations, 1);
  return <div data-id="element-190" data-mp="1jxlpvvei7z4n">
      <Stage label="Members added in period" value={members} color="bg-navy" max={max} compact={compact} data-id="element-191" data-mp="1jxvcra495q64" />
      <Connector label="Conversion rate (unique)" value={fmtPct(conversionRate)} compact={compact} data-id="element-192" data-mp="2vao4wm0yggmp" />
      <Stage label="Unique members who registered" value={registeringMembers} color="bg-digital" max={max} compact={compact} data-id="element-193" data-mp="33bdl6ki5kodb" />
      <Connector label="Registrations per member" value={fmtRatio(regsPerMember)} compact={compact} data-id="element-194" data-mp="37c7bfkj2if9d" />
      <Stage label="Registrations by those members" value={registrations} color="bg-accent" max={max} compact={compact} data-id="element-195" data-mp="3cd3ejvvlhxdq" />
      <p className="mt-3 text-[11.5px] leading-relaxed text-ink-muted" data-id="element-196" data-mp="3hams0tkgy64m">
        Selected-period cohort: only members acquired in the range and the registrations they made in that same range. This differs from counting every registration made in the period regardless of when the member was acquired.
      </p>
    </div>;
}